/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_Vibebids_TitleInputs */

const en_directory_rails_vibebids_title = /** @type {(inputs: Directory_Rails_Vibebids_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VibeBids board`)
};

const zh_directory_rails_vibebids_title = /** @type {(inputs: Directory_Rails_Vibebids_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VibeBids 榜单`)
};

/**
* | output |
* | --- |
* | "VibeBids board" |
*
* @param {Directory_Rails_Vibebids_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_vibebids_title = /** @type {((inputs?: Directory_Rails_Vibebids_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_Vibebids_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_vibebids_title(inputs)
	return zh_directory_rails_vibebids_title(inputs)
});
export { directory_rails_vibebids_title as "directory.rails.vibebids_title" }